// Grilla
import React from 'react';
import { useTheme } from '../ThemeContext';

function Grilla() {
    const { theme } = useTheme();

    // Imágenes para grilla analógica
    const analogGridImages = [
        '/img/cronica-tv.png',
        '/img/canal26.png',
        '/img/canal-local4.png',
        '/img/c5n.png',
        '/img/tn.png',
        '/img/tv-publica.png',
        '/img/encuentro.png',
        '/img/ln.svg',
        '/img/canal9.png',
        '/img/telefe.png',
        '/img/america.png',
        '/img/trece.png',
        '/img/a24.png',
        '/img/canal12.png',
        '/img/ip.png',
        '/img/tyc-sports.png',
        '/img/espn.png',
        '/img/espn2.png',
        '/img/america-sports.png',
        '/img/fox-sports.png',
        '/img/fox-sports2.png',
        '/img/garage.png',
        '/img/depor-tv.svg',
        '/img/paka-paka.png',
        '/img/discovery-kids.png',
        '/img/disney-channel.png',
        '/img/disney-junior.png',
        '/img/cartoon-network.png',
        '/img/cine-ar.png',
        '/img/amc.png',
        '/img/universal.png',
        '/img/tnt.svg',
        '/img/axn.png',
        '/img/cine-canal.png',
        '/img/star-channel.svg',
        '/img/fx.png',
        '/img/space.png',
        '/img/tnt-novelas.png',
        '/img/tcm.png',
        '/img/volver.png',
        '/img/animal-planet.svg',
        '/img/discovery-channel.png',
        '/img/national-geographic.png',
        '/img/history.svg',
        '/img/el-gourmet.png',
        '/img/tele-sur.png',
        '/img/cnn.png',
        '/img/tve.svg',
        '/img/euro-channel.png',
        '/img/dw.png',
        '/img/canal-de-las-estrellas.png',
        '/img/band.png',
        '/img/canal-criador.png',
        '/img/sbt.png',
        '/img/argentinisima.png',
        '/img/rural.png',
        '/img/ewtn.png',
        '/img/magazine.png',
        '/img/quiero-musica.png',
        '/img/tooncast.png',
        '/img/canal-luz.png',
        '/img/enlace.png',
        '/img/nuevo-tiempo.png',
    ];

    // Números grilla analógica
    const analogGridNumbers = [
        '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21',
        '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
        '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57',
        '58', '60', '61', '96', '97', '98', '99'
    ];

    // Imágenes grilla digital
    const digitalGridImages = [
        '/img/canal26.png',
        '/img/c5n.png',
        '/img/tn.png',
        '/img/america.png',
        '/img/a24.png',
        '/img/ln.svg',
        '/img/cronica-tv.png',
        '/img/canal12.png',
        '/img/argentina12.png',
        '/img/canal-local4.png',
        '/img/tv-publica.png',
        '/img/canal9.png',
        '/img/telefe.png',
        '/img/trece.png',
        '/img/tyc-sports.png',
        '/img/fox-sports.png',
        '/img/logo-vallevision-eventos.png',
        '/img/logo-vallevision-eventos2.png',
        '/img/fox-sports2.png',
        '/img/fox-sports3.png',
        '/img/espn.png',
        '/img/espn2.png',
        '/img/espn3.png',
        '/img/espn4.png',
        '/img/depor-tv.svg',
        '/img/sbt.png',
        '/img/canal-criador.png',
        '/img/record.png',
        '/img/france24.png',
        '/img/cgtn.png',
        '/img/cnn.png',
        '/img/rai.png',
        '/img/tve.svg',
        '/img/galicia.png',
        '/img/national-geographic.png',
        '/img/tec-tv.png',
        '/img/encuentro.png',
        '/img/aunar.png',
        '/img/discovery-science.png',
        '/img/discovery-theater.png',
        '/img/discovery-turbo.png',
        '/img/discovery-world.png',
        '/img/discovery-channel.png',
        '/img/discovery-hyh.png',
        '/img/hgtv.png',
        '/img/lifetime.png',
        '/img/tooncast.png',
        '/img/nick.png',
        '/img/cartoonito.png',
        '/img/nick-jr.png',
        '/img/cartoon-network.png',
        '/img/disney-channel.png',
        '/img/disney-junior.png',
        '/img/paka-paka.png',
        '/img/baby-tv.png',
        '/img/kidoo.png',
        '/img/discovery-kids.png',
        '/img/tnt.svg',
        '/img/universal.png',
        '/img/studio-universal.png',
        '/img/cine-ar.png',
        '/img/aye.png',
        '/img/hbo.svg',
        '/img/hbo2.svg',
        '/img/cine-canal.png',
        '/img/axn.png',
        '/img/hbo-mundi.png',
        '/img/hbo-pop.png',
        '/img/hbo-signature.svg',
        '/img/hbo-xtreme.png',
        '/img/hbo-family.png',
        '/img/hbo-plus.png',
        '/img/space.png',
        '/img/europa.png',
        '/img/amc.png',
        '/img/euro-channel.png',
        '/img/cinemax.png',
        '/img/fx.png',
        '/img/warner.png',
        '/img/sony-movies.svg',
        '/img/sony.png',
        '/img/adult.png',
        '/img/e.png',
        '/img/star-channel.svg',
        '/img/tcm.png',
        '/img/amc-series.png',
        '/img/tnt-series.png',
        '/img/tnt-novelas.png',
        '/img/usa-network.png',
        '/img/comedy-central.png',
        '/img/filmyarts.png',
        '/img/magazine.png',
        '/img/canal-a.png',
        '/img/canal-de-la-ciudad.png',
        '/img/cm.png',
        '/img/quiero-musica.png',
        '/img/folkloriko-tv.jpg',
        '/img/htv.png',
        '/img/mtv.png',
        '/img/canal-de-las-estrellas.png',
        '/img/pasiones.png',
        '/img/metro.png',
        '/img/garage.png',
        '/img/america-sports.png',
        '/img/animal-planet.svg',
        '/img/history.svg',
        '/img/history2.png',
        '/img/chacra-tv.png',
        '/img/rural.png',
        '/img/t5.png',
        '/img/argentinisima.png',
        '/img/el-gourmet.png',
        '/img/dw.png',
        '/img/ewtn.png',
        '/img/enlace.png',
        '/img/ejtv.png',
    ];

    // Números grilla digital
    const digitalGridNumbers = [
        '12.1', '12.2', '12.3', '12.4', '13.1', '13.2', '13.3', '13.4', '13.5', '14.1', '14.2', '14.3', '14.4',
        '15.1', '15.2', '15.5', '15.6', '15.7', '16.1', '16.2', '16.3', '16.4', '16.5', '17.1', '17.3', '17.4',
        '17.5', '18.1', '18.2', '18.3', '18.4', '18.5', '18.6', '18.7', '19.1', '19.2', '19.3', '19.4', '19.5',
        '19.6', '19.7', '19.8', '20.1', '20.2', '20.3', '20.4', '20.5', '20.6', '20.7', '20.8', '21.1', '21.2',
        '21.3', '21.4', '21.5', '21.6', '22.1', '22.2', '22.3', '22.4', '22.5', '22.6', '22.7', '22.8', '23.1',
        '23.2', '23.3', '23.4', '23.5', '23.6', '23.7', '23.8', '24.1', '24.2', '24.3', '24.4', '24.5', '25.1',
        '25.2', '25.3', '25.4', '25.5', '25.6', '26.1', '26.2', '26.3', '27.1', '27.2', '27.3', '27.4', '27.5',
        '28.1', '28.2', '28.3', '28.4', '28.5', '28.6', '29.1', '29.2', '29.4', '30.1', '30.2', '30.3', '30.4',
        '30.6', '31.1', '31.2', '31.3', '31.4', '31.5', '31.6', '31.7', '32.1', '32.2', '32.3', '32.4'
    ];

    // Canales HD
    const hdIndexes = [
        0, 1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 34, 39,
        41, 42, 43, 47, 48, 49, 50, 51, 52, 55, 56, 57, 58, 61, 64, 65, 72, 73, 74, 75, 77, 78, 79, 80, 81, 83, 84, 85,
        87, 89, 90, 94, 95, 96, 97, 98, 99, 100, 103, 105, 108, 109, 111, 112, 114, 115
    ];

    return (
        <section className={`grilla contenedor ${theme}`} id="grilla">
            <span className={`degrade1 ${theme}`}></span>
            <span className={`degrade2 ${theme}`}></span>
            <span className={`degrade3 ${theme}`}></span>
            <span className={`degrade4 ${theme}`}></span>

            <div className="grilla-header">
                <div className={`grilla-title ${theme}`}>
                    <h1>
                        Conocé nuestra <br />
                        <strong>Grilla de señales</strong>
                    </h1>
                </div>

                <div className={`grilla-hd ${theme}`}>
                    <span></span>
                    <h3>Señales HD</h3>
                </div>
            </div>

            <div className="grilla-section">
                <h2 className={`grilla-subtitle ${theme}`}>Grilla analógica</h2>
                <div className="grilla-grid">
                    {analogGridImages.map((imageUrl, index) => (
                        <div key={imageUrl} className={`grilla-item ${theme}`}>
                            <div
                                className="grilla-logo"
                                style={{ backgroundImage: `url(${imageUrl})` }}
                            ></div>
                            <div className={`grilla-number ${theme}`}>
                                {analogGridNumbers[index]}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="grilla-section">
                <h2 className={`grilla-subtitle ${theme}`}>Grilla digital</h2>
                <div className="grilla-grid">
                    {digitalGridImages.map((imageUrl, index) => (
                        <div key={imageUrl} className={`grilla-item ${theme}`}>
                            <div
                                className="grilla-logo"
                                style={{ backgroundImage: `url(${imageUrl})` }}
                            ></div>
                            <div className={`grilla-number ${theme}`}>
                                {digitalGridNumbers[index]}
                            </div>
                            {hdIndexes.includes(index) && (
                                <span
                                    className={`grilla-span-hd ${theme}`}
                                    style={{ display: 'block' }}
                                ></span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Grilla;
